var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { BlockingLoadBox } from '../components/misc';
import { ODWebUtils } from '../utils';
export function useSingleQueryAPI(callable, deps) {
    var _this = this;
    var _a = React.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = React.useState(null), error = _b[0], setError = _b[1];
    var _c = React.useState(null), data = _c[0], setData = _c[1];
    var wrapped = React.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var r, ex_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (loading) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setLoading(true);
                    return [4 /*yield*/, callable()];
                case 2:
                    r = _a.sent();
                    setData(r);
                    return [3 /*break*/, 5];
                case 3:
                    ex_1 = _a.sent();
                    setError(ex_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, deps);
    var reload = React.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setError(null);
            setLoading(false);
            // setData(null)
            // noinspection ES6MissingAwait
            wrapped();
            return [2 /*return*/];
        });
    }); }, [wrapped]);
    React.useEffect(function () {
        setError(null);
        setLoading(false);
        // setData(null)
        // noinspection JSIgnoredPromiseFromCall
        wrapped();
    }, [wrapped]);
    return { loading: loading, error: error, data: data, setData: setData, reload: reload };
}
export function SingleQueryWrapper(props) {
    var _this = this;
    var children = props.children, getter = props.getter, update = props.update, deps = props.deps, showLoading = props.showLoading, onError = props.onError, renderError = props.renderError, renderLoading = props.renderLoading, _a = props.ignoreReloadLoading, ignoreReloadLoading = _a === void 0 ? false : _a;
    var _b = useSingleQueryAPI(getter, deps), data = _b.data, loading = _b.loading, error = _b.error, setData = _b.setData, reload = _b.reload;
    var _c = React.useState(false), isUpdating = _c[0], setIsUpdating = _c[1];
    var updateFunc = React.useCallback(function (input) { return __awaiter(_this, void 0, void 0, function () {
        var updated, ex_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, 4, 5]);
                    if (!update) return [3 /*break*/, 2];
                    return [4 /*yield*/, ((_a = update) === null || _a === void 0 ? void 0 : _a(input))];
                case 1:
                    updated = _b.sent();
                    setData(updated);
                    return [2 /*return*/, true];
                case 2: return [3 /*break*/, 5];
                case 3:
                    ex_2 = _b.sent();
                    if (onError) {
                        onError(ex_2);
                    }
                    else {
                        ODWebUtils.showError(ex_2);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setIsUpdating(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/, false];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    if (error) {
        if (renderError) {
            return React.createElement(React.Fragment, null, renderError(error));
        }
        return React.createElement("div", null, error.toString());
    }
    if (!data || (data && !ignoreReloadLoading)) {
        if (loading || !data) {
            if (renderLoading) {
                return React.createElement(React.Fragment, null, renderLoading());
            }
            return React.createElement(BlockingLoadBox, { show: true, message: "loading.." });
        }
    }
    return (React.createElement(React.Fragment, null,
        isUpdating && React.createElement(BlockingLoadBox, { show: true, message: "updating.." }),
        showLoading && React.createElement(BlockingLoadBox, { show: true, message: showLoading }),
        children({ data: data, update: updateFunc, reload: reload })));
}
//# sourceMappingURL=useSingleQueryAPI.js.map